import { configService } from "@/settings/api-url";
import { segment_track, segment_identify } from "@/settings/segment";
import store from "@/store/store";

const actions = {
  async action_autoLogin({ dispatch, commit, getters }, providedToken = null) {
    const token = providedToken || getters.getIsToken;
    if (token) {
      commit("SPINNER", true);
      configService.defaults.headers.common["Authorization"] = token;
      configService.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      commit("IS_TOKEN", token);
      const user = await dispatch("action_getUser");

      let country = getters.getCountry;
      const countryId = (country && country.id) || 2;
      if (!country) {
        await dispatch("action_getCountry", countryId);
        country = getters.getCountry;
      }
      const name = `${user.first_name} ${user.last_name}`;
      commit("SPINNER", false);
      dispatch("loadSegment");
      segment_identify(user.id, name, user.email, user.cellphone, user.created_at);
    } else {
      return Promise.reject("No token provided");
    }
  },
  async action_postLogin({ dispatch, commit }, payload) {
    try {
      const res = await configService("/auth/login.json", {
        method: "POST",
        data: payload,
      });
      const { data } = res;
      const token = data.user.auth_token;
      commit("IS_TOKEN", token);
      dispatch("loadSegment");
      dispatch("action_autoLogin");
      if (store.getters.getIsToken && store.getters.getCart && store.getters.getCart.token_encode) {
        await dispatch("action_linkCartWithUser");
      }
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_postSignup({}, dataReg) {
    try {
      const res = await configService("/user", {
        method: "POST",
        data: dataReg,
      });
      segment_track("user-created", res.data.user);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  loadSegment() {
    new Promise(() => {
      const win = window as any;
      if (!win.analytics) {
        let analytics = (win.analytics = win.analytics || []);
        if (!analytics.initialize)
          if (analytics.invoked) win.console;
          else {
            analytics.invoked = !0;
            analytics.methods = [
              "trackSubmit",
              "trackClick",
              "trackLink",
              "trackForm",
              "pageview",
              "identify",
              "reset",
              "group",
              "track",
              "ready",
              "alias",
              "debug",
              "page",
              "once",
              "off",
              "on",
              "addSourceMiddleware",
              "addIntegrationMiddleware",
              "setAnonymousId",
              "addDestinationMiddleware",
            ];
            analytics.factory = function (e) {
              return function () {
                let t = Array.prototype.slice.call(arguments);
                t.unshift(e);
                analytics.push(t);
                return analytics;
              };
            };
            for (let e = 0; e < analytics.methods.length; e++) {
              let t = analytics.methods[e];
              analytics[t] = analytics.factory(t);
            }
            analytics.load = function (e, t) {
              let n = document.createElement("script");
              n.type = "text/javascript";
              n.async = !0;
              n.src = "https://cdn.segment.com/analytics.js/v1/" + e + "/analytics.min.js";
              let a = document.getElementsByTagName("script")[0];
              a.parentNode.insertBefore(n, a);
              analytics._loadOptions = t;
            };
            analytics.SNIPPET_VERSION = "4.1.0";
            analytics.load("SE6Zm5Mdd51N0NlQkQi0Pv6f1j1k4Syd");
          }
      }
    });
  },
  async action_postResetPassword({}, data) {
    try {
      const res = await configService(`password_resets`, {
        method: "POST",
        data,
      });
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_putResetPassword({}, payload) {
    try {
      const res = await configService(`/password_resets/${payload.token}?email=${payload.email}`, {
        method: "PUT",
        data: payload.data,
      });
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async action_getLoginEmail({}, data) {
    try {
      const res = await configService(`users/check_email_existence?email=${data}`);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_getLoginCellSearch({}, data) {
    try {
      const res = await configService(`users/check_email_by_phone?cellphone=${data}`);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_getLoginTemporaryCode({ commit, dispatch }, data) {
    try {
      const res = await configService(`users/auth_by_temporary_code`, {
        method: "POST",
        data,
      });
      const token = res.data.token;
      await commit("IS_TOKEN", token);
      configService.defaults.headers.common["Authorization"] = token;
      configService.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      dispatch("action_autoLogin");
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_getLoginCodeCell({}, data) {
    try {
      const res = await configService(`users/get_sms_code?cellphone=${data}`);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async action_getLoginCodeCellWhatsapp({}, data) {
    try {
      const res = await configService(`users/get_wa_link?cellphone=${data}`);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async action_postLoginCode({ commit, dispatch }, data) {
    try {
      const res = await configService(`users/validate_code`, {
        method: "POST",
        data,
      });
      const token = res.data.token;
      await commit("IS_TOKEN", token);
      configService.defaults.headers.common["Authorization"] = token;
      configService.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      if (store.getters.getIsToken && store.getters.getCart && store.getters.getCart.token_encode) {
        await dispatch("action_linkCartWithUser");
      }
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async action_getCreateCodeCell({}, data) {
    try {
      const res = await configService(`users/get_sms_code?cellphone=${data}&is_new_user=true`);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async action_getCreateCodeCellWhatsapp({}, data) {
    try {
      const res = await configService(`users/get_wa_link?cellphone=${data}&is_new_user=true`);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async action_postVerifyCodeOnly({}, data) {
    // Verify without verification exist user
    try {
      const res = await configService(`users/validate_code_new_user?cellphone=${data.cellphone}`, {
        method: "POST",
        data,
      });
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

export default actions;
